/* eslint-disable no-undef */
const DEBUG = process.env.NODE_ENV === "development";

function mctapihost(): string {
  if (DEBUG) {
    return "//localhost:8080";
  }
  if (window.location.hostname.includes("s3-website")) {
    return "//test.medicare.gov";
  }
  return "";
}

const FE_VERSION: string = process.env.REACT_APP_RELEASE_VERSION || "Unknown";

const MCTAPI_PATH: string = DEBUG ? "" : "/api/v1/data/plan-compare";
const MCTAPI_URI: string = process.env.REACT_APP_MCTAPI_URI
  ? process.env.REACT_APP_MCTAPI_URI
  : `${mctapihost()}${MCTAPI_PATH}`;
const USE_LOCAL_PROXY = process.env.REACT_APP_USE_LOCAL_PROXY || false;

// Launch Darkly Variables
const LD_BASE_URL = process.env.REACT_APP_LD_BASE_URL || "Not Set";
const LD_CLIENT_ID = process.env.REACT_APP_LD_CLIENT_ID || "Not Set";
const LD_EVENTS_URL = process.env.REACT_APP_LD_EVENTS_URL || "Not Set";
const LD_STREAM_URL = process.env.REACT_APP_LD_STREAM_URL || "Not Set";

// Mapbox Variables
const MAPBOX_ACCESS_TOKEN = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN || false;

const ANON_ENROLL_BASE_URL =
  process.env.REACT_APP_ANON_ENROLL_BASE_URL ||
  "https://test.enrollmentcenter.medicare.gov";

export const USER_INACTIVITY_TIMEOUT_IN_MS = process.env
  .REACT_APP_USER_INACTIVITY_TIMEOUT_IN_MS
  ? parseInt(process.env.REACT_APP_USER_INACTIVITY_TIMEOUT_IN_MS)
  : 1000 * 60 * 15; // default 15 minutes
export const USER_LOGOUT_TIMEOUT_IN_MS = process.env
  .REACT_APP_USER_LOGOUT_TIMEOUT_IN_MS
  ? parseInt(process.env.REACT_APP_USER_LOGOUT_TIMEOUT_IN_MS)
  : 1000 * 60 * 5; // default 5 minutes

declare global {
  interface Window {
    config: Record<string, unknown>;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    newrelic: any;
  }
}

export const config = (window.config = {
  ANON_ENROLL_BASE_URL,
  DEBUG,
  FE_VERSION,
  MAPBOX_ACCESS_TOKEN,
  MCTAPI_URI,
  LD_BASE_URL,
  LD_CLIENT_ID,
  LD_EVENTS_URL,
  LD_STREAM_URL,
  USE_LOCAL_PROXY,
});
